<template>
    <div class="container-fluid">
        <div v-if="$can('serviceorder create')" class="row justify-content-center h-100">
            <div class="default-page-width h-100">
                <div class="card card-default h-100">
                    <div class="card-header">{{$t('service.'+mode+'.title')}}</div>
                    <div class="card-body">
                        <div class="h-100">
                            <form-service
                                :mode="'create'"
                                :context="context"
                                :presetobjectid=rmsobjectid
                            ></form-service>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h1 v-if="!$can('serviceorder create')">{{$t('access-denied')}}</h1>
    </div>
</template>

<script>

import FormService from "./form-service.vue";

export default {
    name: "service-order-create",
    components: {FormService},
    props: {
        user: [String, Number],
        mode: {
            type: String,
            default: 'create'
        },
        context:[String],
        rmsobjectid:[Number],
        customerid:[Number]
    },
    data: function () {
        return {
            presetRmsObjectId: undefined
        }
    },
    mounted() {
        console.log("service-order-create init... ", this.orderid, this.mode, this.context);
    },

}
</script>

<style scoped>

</style>
